import { Link, Button, Box, Stack, Typography } from "fashion/fabrics";
import { STATIC_ROUTES } from "nodes/codex/CodexRoutes";
import { LocalShippingIcon, SearchIcon } from "fashion/icons";
import CodexPhysicalPricingGrid from "nodes/codex/CodexPhysicalPricingGrid";

const CodexPhysicalPricing = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      Physical prints{" "}
      <Box component="span" color="secondary.main" display="inline">
        Pricing
      </Box>
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      Order card prints at $0.5 to $1 per card and{" "}
      <Box color="secondary.main" component="span" display="inline">
        free worldwide shipping.
      </Box>
    </Typography>
    <CodexPhysicalPricingGrid />
    <Box margin="auto">
      <Button
        component={Link}
        href={STATIC_ROUTES.BLOG_ORDER_PHYSICAL_PRINTS}
        size="large"
        variant="outlined"
        color="secondary"
        startIcon={<SearchIcon />}
        endIcon={<LocalShippingIcon />}
      >
        How to order
      </Button>
    </Box>
  </Stack>
);

export default CodexPhysicalPricing;
